import React from "react";
import { attendanceCellLabel, attendanceCellTooltip } from "../../utils/carryForwardCopy";

function cellClassName({ batchMode, overrideCarryForward, emphasized }) {
    if (batchMode === "ALLOWED" || batchMode === "NOT_ALLOWED") {
        return "text-xs px-2 py-1 rounded bg-gray-100 text-gray-600 font-medium cursor-help";
    }
    if (overrideCarryForward === null || overrideCarryForward === undefined) {
        return "text-xs px-2 py-1 rounded bg-gray-100 text-gray-600 font-medium cursor-help";
    }
    if (overrideCarryForward) {
        return `text-xs px-2 py-1 rounded bg-green-100 text-green-700 ${emphasized ? "font-semibold" : "font-medium"} cursor-help`;
    }
    return `text-xs px-2 py-1 rounded bg-red-100 text-red-700 ${emphasized ? "font-semibold" : "font-medium"} cursor-help`;
}

export default function CarryForwardCell({ batchMode, overrideCarryForward, emphasized = false }) {
    const label = attendanceCellLabel({ batchMode, overrideCarryForward });
    const tooltip = attendanceCellTooltip({ batchMode, overrideCarryForward });

    return (
        <span className={cellClassName({ batchMode, overrideCarryForward, emphasized })} title={tooltip}>
            {label}
        </span>
    );
}
